export default __webpack_public_path__ + "static/media/link.3b1c69d8.svg";